export default "__VITE_ASSET__2271783e__"